function minutesToMillis() {

  let minutesToMillisDirective = {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      function toMillis(minutes) {
        console.log("%o", ngModel );
        return minutes * 60000;
      }

      function toMinutes(millis) {
        console.log("%o", ngModel );
        return (millis % (3600 * Math.pow(10,3)))/60000;
      }

      ngModel.$parsers.push(toMillis);
      ngModel.$formatters.push(toMinutes);
    }
  };

  return minutesToMillisDirective;

}

export default minutesToMillis;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/activationHourServices/minutesToMillis.js
 **/